import { ShieldCheck } from "lucide-react";

interface VerifiedBadgeProps {
  variant?: "light" | "dark";
  size?: "sm" | "md" | "lg";
}

const VerifiedBadge = ({ variant = "light", size = "md" }: VerifiedBadgeProps) => {
  const isDark = variant === "dark";
  
  const sizeClasses = {
    sm: "px-3 py-1.5 text-xs gap-1.5",
    md: "px-4 py-2 text-sm gap-2",
    lg: "px-5 py-2.5 text-base gap-2.5"
  };

  const iconSizes = {
    sm: "w-3.5 h-3.5",
    md: "w-4 h-4",
    lg: "w-5 h-5"
  };

  return (
    <div 
      className={`inline-flex items-center rounded-full font-medium transition-all duration-300 hover:scale-105 ${sizeClasses[size]} ${
        isDark 
          ? "bg-gold/20 text-gold border border-gold/30" 
          : "bg-gold/10 text-gold border border-gold/40"
      }`}
    >
      <ShieldCheck className={`${iconSizes[size]} fill-gold/20`} />
      <span>100% מאומתי זהות</span>
    </div>
  );
};

export default VerifiedBadge;
